import {FC} from 'react';

type Icon = {
    className?: string;
};

const Fill: FC<Icon> = ({className}) => (
    <svg width="18" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path
            d="m16.297 4.697.707-.707-.707.707Zm-2.594-2.594.707-.707-.707.707ZM4.2 8.4a1 1 0 0 0 0 2v-2Zm4.8 2a1 1 0 0 0 0-2v2Zm-4.8 1.2a1 1 0 1 0 0 2v-2Zm9.2 2a1 1 0 1 0 0-2v2Zm-1.2 6H5.8v2h6.4v-2ZM2 15.8V6.2H0v9.6h2ZM17.004 3.99 14.41 1.396 12.996 2.81l2.594 2.594 1.414-1.414ZM5.8 2.4h5.6v-2H5.8v2Zm5.6 0h.606v-2H11.4v2Zm-1-1v3.2h2V1.4h-2ZM16 6.394V7h2v-.606h-2ZM16 7v8.8h2V7h-2Zm-2.2 1H17V6h-3.2v2Zm-3.4-3.4A3.4 3.4 0 0 0 13.8 8V6a1.4 1.4 0 0 1-1.4-1.4h-2Zm4.01-3.204A3.4 3.4 0 0 0 12.006.4v2a1.4 1.4 0 0 1 .99.41l1.414-1.414Zm1.18 4.008a1.4 1.4 0 0 1 .41.99h2a3.4 3.4 0 0 0-.996-2.404L15.59 5.404ZM5.8 19.6A3.8 3.8 0 0 1 2 15.8H0a5.8 5.8 0 0 0 5.8 5.8v-2Zm6.4 2a5.8 5.8 0 0 0 5.8-5.8h-2a3.8 3.8 0 0 1-3.8 3.8v2ZM2 6.2a3.8 3.8 0 0 1 3.8-3.8v-2A5.8 5.8 0 0 0 0 6.2h2Zm2.2 4.2H9v-2H4.2v2Zm0 3.2h9.2v-2H4.2v2Z"
            fill="#C5CDF8"
        />
    </svg>
);

export default Fill;
